export const collection = [
  { name: "mango", en: "The mango", el: "Το μάνγκο" },
  { name: "coconut", en: "A little surprise", el: "Μια μικρή έκπληξη" },
  { name: "orange", en: "The orange", el: "Το πορτοκάλι" },
  { name: "bow", en: "Tied with love", el: "Δεμένο με αγάπη" },
  { name: "boutique", en: "Inside the boutique", el: "Στο κατάστημά μας" },
  {
    name: "maya",
    en: "Maya and her creations",
    el: "Η Μάγια και οι δημιουργίες της",
  },
  { name: "maya-birthday", en: "Birthday moments", el: "Στιγμές γενεθλίων" },
  {
    name: "maya-balcony",
    en: "A moment on the balcony",
    el: "Μια στιγμή στο μπαλκόνι",
  },
  {
    name: "maya-terrace",
    en: "A smile from Maya",
    el: "Ένα χαμόγελο από τη Μάγια",
  },
  ...[1, 2, 3, 4, 6, 8, 9].map((n, i) => ({
    name: `archive-${n}`,
    archive: true,
    en: `From our collection · ${i + 1}`,
    el: `Από τη συλλογή μας · ${i + 1}`,
  })),
  {
    name: "press-cheese",
    archive: true,
    en: "Cheese-shaped dessert on a pink plate",
    el: "Γλυκό σε σχήμα τυριού σε ροζ πιάτο",
  },
  {
    name: "press-coffee",
    archive: true,
    en: "Coffee-bean-shaped dessert",
    el: "Γλυκό σε σχήμα κόκκου καφέ",
  },
  {
    name: "press-dessert-selection",
    archive: true,
    en: "Colourful fruit-shaped dessert selection",
    el: "Πολύχρωμη συλλογή γλυκών σε σχήμα φρούτων",
  },
];
export const copy = {
  en: {
    announcement: "A little wonder. A lot of flavour.",
    visit: "Visit us in Latsia",
    wordmark: "THE ART OF A SWEET SURPRISE",
    navigation: "Main navigation",
    call: "Call 96 420156",
    menu: "Toggle menu",
    skip: "Skip to content",
    heroLabel: "FRENCH-INSPIRED PATISSERIE · CYPRUS",
    heroTitle: "Looks like fruit.",
    heroAccent: "Tastes like magic.",
    heroIntro:
      "A little unexpected. Completely unforgettable. Discover Maya’s trompe-l’œil desserts — playful on the outside, pure indulgence within.",
    explore: "Explore the creations",
    heroNote: "A feast for the eyes.",
    heroNoteAccent: "A moment to savour.",
    heroAlt:
      "A selection of colourful fruit-shaped desserts in Maya’s pink boutique",
    madeWithLove: "MADE WITH LOVE",
    sealTop: "A SWEET",
    sealBottom: "SURPRISE",
    ribbon1: "Made to surprise",
    ribbon2: "Loved at first bite",
    collectionLabel: "The creations",
    collectionTitle: "Almost too beautiful",
    collectionAccent: "to take a bite.",
    collectionIntro:
      "Look a little closer. These are desserts with a delicious secret. Which one will be your first?",
    availability: "A glimpse of our creations. Call us for today’s selection.",
    showMore: "More sweet inspiration",
    showLess: "Show fewer creations",
    viewPhoto: "View photograph",
    close: "Close photograph",
    previous: "Previous photograph",
    next: "Next photograph",
    storyLabel: "The heart behind the flavour",
    storyTitle: "A little imagination.",
    storyAccent: "A lot of Maya.",
    storyIntro:
      "Behind every sweet surprise is Maya Panayi: a pastry creator with a love for detail, a playful imagination and a style all her own.",
    mayaAlt:
      "Maya in a red dress celebrating her birthday beside a colourful dessert collection",
    storyFootnote: "Sweet creations. Personal celebrations.",
    followStory: "Follow Maya’s story",
    reviewsLabel: "Sweet words",
    reviewsTitle: "The sweetest part?",
    reviewsAccent: "Your words.",
    googleReviews: "Explore reviews on Google",
    selectedReviews: "Selected Google reviews",
    translated: "Translated from Greek",
    translatedEnglish: "Translated from English",
    readReview: "Read review",
    reviewed: "Review selection verified 16 September 2026",
    visitLabel: "Come for a little wonder",
    visitTitle: "Your next sweet stop.",
    visitAccent: "See you in Latsia.",
    visitIntro:
      "Pick up a little joy for yourself, or something lovely to share. For orders and availability, give us a call.",
    address: "11 Lefkosias Street",
    enquiries: "ORDERS & ENQUIRIES",
    instagramTitle: "A little sweetness in your feed.",
    footerTagline: "Extraordinary little moments.",
  },
  el: {
    announcement: "Μικρές εκπλήξεις. Μεγάλη απόλαυση.",
    visit: "Βρείτε μας στα Λατσιά",
    wordmark: "Η ΤΕΧΝΗ ΤΗΣ ΓΛΥΚΙΑΣ ΕΚΠΛΗΞΗΣ",
    navigation: "Κύρια πλοήγηση",
    call: "Καλέστε 96 420156",
    menu: "Άνοιγμα / κλείσιμο μενού",
    skip: "Μετάβαση στο περιεχόμενο",
    heroLabel: "ΓΑΛΛΙΚΗ ΕΜΠΝΕΥΣΗ · ΚΥΠΡΟΣ",
    heroTitle: "Μοιάζει με φρούτο.",
    heroAccent: "Γεύση που μαγεύει.",
    heroIntro:
      "Μια μικρή έκπληξη. Μια αξέχαστη απόλαυση. Ανακαλύψτε τα trompe-l’œil γλυκά της Μάγιας — παιχνιδιάρικα στην όψη, απολαυστικά σε κάθε μπουκιά.",
    explore: "Γνωρίστε τις δημιουργίες",
    heroNote: "Μια απόλαυση για τα μάτια.",
    heroNoteAccent: "Μια στιγμή μόνο για εσάς.",
    heroAlt: "Πολύχρωμα γλυκά σε σχήμα φρούτων στο ροζ κατάστημα της Μάγιας",
    madeWithLove: "ΜΕ ΑΓΑΠΗ",
    sealTop: "ΓΛΥΚΙΑ",
    sealBottom: "ΕΚΠΛΗΞΗ",
    ribbon1: "Φτιαγμένα για να εκπλήσσουν",
    ribbon2: "Αγάπη με την πρώτη μπουκιά",
    collectionLabel: "Οι δημιουργίες",
    collectionTitle: "Σχεδόν πολύ όμορφα",
    collectionAccent: "για μια μπουκιά.",
    collectionIntro:
      "Κοιτάξτε λίγο πιο κοντά. Κάθε γλυκό κρύβει ένα απολαυστικό μυστικό. Ποιο θα δοκιμάσετε πρώτο;",
    availability:
      "Μια γεύση από τις δημιουργίες μας. Καλέστε για τη σημερινή ποικιλία.",
    showMore: "Περισσότερη γλυκιά έμπνευση",
    showLess: "Λιγότερες δημιουργίες",
    viewPhoto: "Προβολή φωτογραφίας",
    close: "Κλείσιμο φωτογραφίας",
    previous: "Προηγούμενη φωτογραφία",
    next: "Επόμενη φωτογραφία",
    storyLabel: "Η καρδιά πίσω από τη γεύση",
    storyTitle: "Λίγη φαντασία.",
    storyAccent: "Πολλή Μάγια.",
    storyIntro:
      "Πίσω από κάθε γλυκιά έκπληξη βρίσκεται η Μάγια Παναγή: μια δημιουργός με αγάπη για τη λεπτομέρεια, παιχνιδιάρικη φαντασία και τη δική της ταυτότητα.",
    mayaAlt:
      "Η Μάγια με κόκκινο φόρεμα γιορτάζει τα γενέθλιά της δίπλα στις πολύχρωμες δημιουργίες της",
    storyFootnote: "Γλυκές δημιουργίες. Προσωπικές στιγμές.",
    followStory: "Ακολουθήστε την ιστορία της Μάγιας",
    reviewsLabel: "Γλυκά λόγια",
    reviewsTitle: "Το πιο γλυκό κομμάτι;",
    reviewsAccent: "Τα λόγια σας.",
    googleReviews: "Δείτε τις κριτικές στο Google",
    selectedReviews: "Επιλεγμένες κριτικές από το Google",
    translated: "Μετάφραση από τα Ελληνικά",
    translatedEnglish: "Μετάφραση από τα Αγγλικά",
    readReview: "Δείτε την κριτική",
    reviewed: "Επιλογή κριτικών: 16 Σεπτεμβρίου 2026",
    visitLabel: "Ελάτε για μια μικρή έκπληξη",
    visitTitle: "Η επόμενη γλυκιά στάση.",
    visitAccent: "Σας περιμένουμε στα Λατσιά.",
    visitIntro:
      "Μια μικρή χαρά για εσάς ή κάτι ξεχωριστό για να μοιραστείτε. Για παραγγελίες και διαθεσιμότητα, καλέστε μας.",
    address: "Λεωφόρος Λευκωσίας 11",
    enquiries: "ΠΑΡΑΓΓΕΛΙΕΣ & ΠΛΗΡΟΦΟΡΙΕΣ",
    instagramTitle: "Λίγη γλύκα στην καθημερινότητά σας.",
    footerTagline: "Μικρές στιγμές. Ξεχωριστές γεύσεις.",
  },
};
